import { FC, useMemo } from 'react';
import { useRouter } from 'next/router';
import { BOOKING_BUTTONS_BY_LOCALE } from 'components/Header/HeaderBookingButton';
import AvatarMulti from 'components/Icons/AvatarMulti';
import Edit from 'components/Icons/Edit';
import KeyboardInput from 'components/Icons/KeyboardInput';
import Upload from 'components/Icons/Upload';
import UIBlockButton from 'components/Others/UIBlockButton';

interface PrescriptionInitialTab {
  isMultifocal: boolean;
  // eslint-disable-next-line no-unused-vars
  actionClickHandler: (action: GuestPrecriptionInitialTabAction) => void;
}

export type GuestPrecriptionInitialTabAction =
  | 'UPLOAD_PRESCRIPTION'
  | 'ENTER_PRESCRIPTION'
  | 'LOGIN'
  | 'BOOKING';

const GuestPrecriptionInitialTab: FC<PrescriptionInitialTab> = ({
  isMultifocal,
  actionClickHandler
}) => {
  const router = useRouter();

  const bookingButtonAttributes = useMemo(
    () => BOOKING_BUTTONS_BY_LOCALE?.[router.locale as string],
    [router]
  );

  return (
    <div className="w-full">
      <div className="flex flex-col">
        {isMultifocal && (
          <div className="border-b border-brand-grey500 pt-[3px] pb-[1px]">
            <UIBlockButton
              onClick={() => actionClickHandler('UPLOAD_PRESCRIPTION')}
              icon={<Upload fill="currentColor" />}
              title="Upload your prescription"
              description="You can upload your prescription"
            />
          </div>
        )}
        <div className="border-b border-brand-grey500 pt-[3px] pb-[1px]">
          <UIBlockButton
            onClick={() => actionClickHandler('ENTER_PRESCRIPTION')}
            icon={<Edit fill="currentColor" />}
            title="Enter your prescription"
            description="Enter your prescription details using a form"
          />
        </div>
        <div className="border-b border-brand-grey500 pt-[3px] pb-[1px]">
          <UIBlockButton
            onClick={() => actionClickHandler('LOGIN')}
            icon={<AvatarMulti fill="currentColor" />}
            title="I saved my prescription before"
            description="Login to your Dresden account"
          />
        </div>
      </div>
      {bookingButtonAttributes && (
        <div className="mt-[60px] w-full">
          <UIBlockButton
            flat
            onClick={() =>
              (window.location.href = bookingButtonAttributes.path)
            }
            icon={<KeyboardInput fill="currentColor" />}
            description={bookingButtonAttributes.text}
            title="I don't have prescription"
          />
        </div>
      )}
    </div>
  );
};

export default GuestPrecriptionInitialTab;
